var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 28L24.5007 36L40.5007 20M55.1673 28C55.1673 42.7276 43.2282 54.6667 28.5007 54.6667C13.7731 54.6667 1.83398 42.7276 1.83398 28C1.83398 13.2724 13.7731 1.33337 28.5007 1.33337C43.2282 1.33337 55.1673 13.2724 55.1673 28Z",
    stroke: "#37A372",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestSent);
export default __webpack_public_path__ + "static/media/Request_sent.7e61f239dae454a318fba0dbaa063ce0.svg";
export { ForwardRef as ReactComponent };